import * as React from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import CardOverflow from "@mui/joy/CardOverflow";
import Divider from "@mui/joy/Divider";
import Typography from "@mui/joy/Typography";
import { TestLanguage } from "../hooks/testLanguage";
import { MdLocationOn } from "react-icons/md";
import { useFetchData } from "../hooks/useFetchData";
import { Link, redirect, useNavigate } from "react-router-dom";
import CardMedia from "@mui/material/CardMedia";
import { TbWorldWww } from "react-icons/tb";
import { MdEmail } from "react-icons/md";
import { FaSquarePhone } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

export default function Developercard({ i, setSelected, selected }) {
  const [dataofdeveloper, setDataofdeveloper] = React.useState();
  const navigate = useNavigate();
  const handleclick = (id) => {
    setSelected(id);
    navigate(``);
  };
  const { t } = useTranslation();

  return (
    <Card
      sx={{
        transition: "transform 0.3s ease-in-out",
        padding: "0",
        "&:hover": {
          transform: "scale(1.050)", // Zoom effect
          boxShadow: "lg", // optional: add shadow on hover
        },
        margin: "5%",
        display: "block",
        height: "450px",
        fontFamily:'oswald,cairo',
        direction: t("directions.dir"),
      }}
    >
      <Link
        to={`/projectofdeveloper/${selected || i?.id}`}
        style={{ textDecoration: "none" }}
      >
        <CardMedia
          sx={{ height: 250, borderRadius: "8px 8px 0 0px" , backgroundSize:'auto'}}
          image={`${process.env.REACT_APP_IMAGE}${i.developer_image}`}
          title="green iguana"
        />

      
        <CardContent sx={{ padding: "16px",}}>
          <Typography
            sx={{ fontWeight: "md", fontSize: "20px" , fontFamily:'oswald,cairo', }}
            level="title-md"
          >
            {TestLanguage(i, "developer_name")}
          </Typography>
          <Typography
            sx={{ fontWeight: "md", fontSize: "15px", fontFamily:'oswald,cairo' }}
            level="body-sm"
          >
            <MdLocationOn />
            {TestLanguage(i, "developer_address")}
          </Typography>
          <Typography
            sx={{ fontWeight: "md", fontSize: "10px" , fontFamily:'oswald,cairo'}}
            level="body-sm"
          >
            {TestLanguage(i, "developer_description")}
          </Typography>
        </CardContent>  
       
          
          <CardContent sx={{ padding: "8px", bottom:'0', position:'absolute', borderTop:'1px solid gray', width:'100%'}} orientation="horizontal">
            <Typography
              level="body-xs"
              textColor="text.secondary"
              sx={{ fontWeight: "md", fontSize: "10px", fontFamily:"oswald,cairo",margin:'5px' }}
            >
              <TbWorldWww size={22} />  {" "}{i?.developer_website}
            </Typography>
            <Divider orientation="vertical" />
            <Typography
              level="body-xs"
              textColor="text.secondary"
              sx={{ fontWeight: "md", fontSize: "10px", fontFamily:"oswald,cairo",margin:'5px' }}
            >
              <FaSquarePhone size={22} /> {" "}
              {i?.developer_phone}
            </Typography>
            <Divider orientation="vertical" />
            <Typography
              level="body-xs"
              textColor="text.secondary"
              sx={{ fontWeight: "md", fontSize: "10px", fontFamily:"oswald,cairo",margin:'5px' }}
            >
              <MdEmail size={22} /> {" "}
              {i?.developer_email}
            </Typography>
          </CardContent>
        
      </Link>
    </Card>
  );
}
